import styled from "styled-components";
export const Container = styled.div`
  display: flex;
  flex-direction: ${({ direction }: { direction?: "row" | "column" }) =>
    direction ? direction : "column"};
  flex: 1;
  max-width: 100vw;
  max-height: 100vh;
`;
